import http from "../core/http";
import { withFlightDateCache } from "../cache/flightListCache";

const group = 'bagFinder';

export const searchBagsRequest = async (data) =>
    await http.post(`${group}/get`, data).then(r => r.data).catch(http.defaultCatch);

// Reuse existing bag endpoints for mutations and dropdown lists
export const updateDataRequest = async (data) =>
    await http.post('bags/update', data).then(r => r.data).catch(http.defaultCatch);

export const deleteDataRequest = async (data) =>
    await http.post('bags/delete', data).then(r => r.data).catch(http.defaultCatch);

export const getBagStatusListRequest = async (data) =>
    await http.post('bags/getBagStatusList', data).then(r => r.data).catch(http.defaultCatch);

export const getForwardTypeListRequest = async (data) =>
    await http.post('bags/getForwardTypeList', data).then(r => r.data).catch(http.defaultCatch);

export const getDamageBagClaimListRequest = async (data) =>
    await http.post('bags/getDamageBagClaimList', data).then(r => r.data).catch(http.defaultCatch);

export const getArrivalFlightListRequest = async (data) =>
    withFlightDateCache("caseFiles/getArrivalFlightList", data, (d) =>
        http.post("caseFiles/getArrivalFlightList", d).then(r => r.data).catch(http.defaultCatch)
    );

export const getDepartureFlightListRequest = async (data) =>
    withFlightDateCache("caseFiles/getDepartureFlightList", data, (d) =>
        http.post("caseFiles/getDepartureFlightList", d).then(r => r.data).catch(http.defaultCatch)
    );
